import React from 'react'
import { Modal } from 'react-bootstrap'
import i18next from 'i18next'

export default class OrderCreditsModal extends React.Component {
  render() {
    const { isModalVisible, handleClose } = this.props

    return (
      <Modal show={isModalVisible} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{i18next.t('order_more_wopi_credits_title')}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ borderRadius: 6 }}>
          <p>
            {i18next.t('order_more_wopi_credits_by_contacting')}{' '}
            <a href="mailto:helpdesk@wopi.net">{i18next.t('mail_to_wopi_helpdesk')}</a>{' '}
            {i18next.t('order_more_wopi_credits_or_by_phone')}{' '}
            <a href="tel:+358405486953">+358 405486953</a>.
          </p>

          <p>
            <a href="#" onClick={handleClose}>
              {i18next.t('close')}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderCreditsModal.js